module.exports = __webpack_public_path__ + "img/full4-min.9642475e.png";